import { Component, OnInit } from '@angular/core';
import {DiamondPayDataService} from "../diamond-pay-data-service.service";
import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-matched-transaction-detail',
  templateUrl: './matched-transaction-detail.component.html',
  styleUrls: ['./matched-transaction-detail.component.css'],
  providers: [DiamondPayDataService],
})
export class MatchedTransactionDetailComponent implements OnInit {
  private transaction: any;
  private routeSubscription: Subscription;

  constructor(private dataService:  DiamondPayDataService,
              private route:        ActivatedRoute,
              private router:       Router) { }

  ngOnInit() {
    this.routeSubscription = this.route.params.subscribe(params => {
      this.dataService
            .RetrieveDiamondPayTransaction(params['id'])
            .subscribe((data:any) => this.transaction = data, error => console.log(error));
    });
  }

  moveToUnmatched(diamondPayTransactionId) {
      this.dataService.moveToUnmatched(diamondPayTransactionId)
          .subscribe((data:any) => {
            if (data.status == 'success') {
                this.router.navigateByUrl('/app/diamond-pay/matched-transactions');
            } else {
                alert('There was a problem with your request. Please try again later.');
            }
          }, error => { console.log(error); alert('There was a problem with your request. Please try again later.'); });
  }

}



// WEBPACK FOOTER //
// ./src/app/matched-transaction-detail/matched-transaction-detail.component.ts